import { LargeurStation } from './largeur-station';

export class MesureStation {
    id: number; // For IndexedDB
    processId: number;


    LpbEstimee: number;
    LineaireParcouru: number;
    // LpbMoyenne: number;
    // LtCalculee: number;
    LtReelle: number;
    // LmMoyenne: number;
    // Smouillee: number;
    // SMaxMarg: number;
    LargeurStations: LargeurStation[] = [];

    constructor() {
    }
    
    static fillLargeurStationList(largeurStations: LargeurStation[]) {
        for (let i = largeurStations.length; i < 10; i++) {
            largeurStations.push(new LargeurStation());
        }

    }

    static mapFromJSON(json: any): MesureStation {
        const m = new MesureStation();

        // m.LmMoyenne = json.lmMoyenne;
        m.LineaireParcouru = json.lineaireParcouru;
        m.LpbEstimee = json.lpbEstimee;
        // m.LpbMoyenne = json.lpbMoyenne;
        // m.Smouillee = json.smouillee;
        // m.SMaxMarg = json.sMaxMarg;
        m.LtReelle = json.ltReelle;
        if (json.largeurStations) {
            m.LargeurStations = json.largeurStations.map(jsonItem => LargeurStation.mapFromJSON(jsonItem));
        }
        
        // this.fillLargeurStationList(m.LargeurStations);

        return m;
    }
}
